import React from 'react';

import {Scroll} from '@pb/kit-component-scroll';
import {hashedClasses} from '@pb/kit-util-with-css-module';

import styles from './dropdown.module.styl';

import type {ReactNode} from 'react';


const classnames = hashedClasses(styles);


type Props = {
    children: ReactNode,
};

export const Body = ({children}: Props) => (
    <Scroll className={classnames.body}>
        {children}
    </Scroll>
);
